import Highcharts from "highcharts";
import { useMemo } from "react";
import BaseScoringChart from "./BaseScoringChart";

const BUBBLE_CHART_TYPE = {
  BUBBLE: "bubble",
  SCATTER: "scatter",
};

export default function BubbleChart({ series, isLoading = false, type = BUBBLE_CHART_TYPE.SCATTER, option, ...props }) {
  const options = useMemo(() => {
    return Highcharts.merge(
      {
        chart: {
          type: type,
        },
        title: {
          text: undefined,
        },
        yAxis: {
          labels: {
            enabled: false,
          },
          title: {
            text: undefined,
          },
          gridLineWidth: 0,
        },
        xAxis: {
          crosshair: {
            color: "#7E94BD",
            width: 0,
          },
          labels: {
            enabled: true,
          },
        },
        plotOptions: {
          scatter: {
            marker: {
              symbol: "circle",
            },
            lineWidth: 0,
            states: {
              hover: {
                lineWidth: 0,
              },
            },
            threshold: null,
          },
        },
        series: series,
        tooltip: {
          enabled: true,
          shared: true,
          style: {
            display: "none",
          },
        },
        legend: {
          enabled: false,
        },
      },
      option
    );
  }, [series, option]);

  return <BaseScoringChart isLoading={isLoading} highcharts={Highcharts} options={options} {...props} />;
}
